import { createAsyncThunk } from "@reduxjs/toolkit"

import apiClient from "src/apiClient"
import { basicTrainingPendingFrom } from "src/utils/training"

import userReducers from "../reducers"

export const thunk = createAsyncThunk("user/me", async (_, { rejectWithValue }) => {
  try {
    const response = await apiClient.get("/users/me/")
    return {
      id: response.data.id,
      username: response.data.username,
      email: response.data.email,
      rankingPoints: response.data.ranking_points,
      // The place in the ranking, counted by the server so the ranking page can point at a player
      // the top-100 list stops above.
      rankingPosition: response.data.ranking_position ?? null,
      // Whether this account can sign in with Google, and whether a password still backs it —
      // the profile screen offers link or unlink from these two.
      googleLinked: response.data.google_linked,
      googleEmail: response.data.google_email ?? null,
      hasPassword: response.data.has_password,
      // When they may next rename, so the profile draws the button in the right state the first
      // time it is opened rather than after a refusal.
      nextUsernameChangeAt: response.data.next_username_change_at,
      // Whether the tutorial has yet to open for this account (`routes.js` walks them in while it
      // is). The server's answer and not this browser's memory, so it holds across devices.
      basicTrainingPending: basicTrainingPendingFrom(response.data),
      // A guest account (2026-10-02): a made-up address, no password, no shop, and a way to save it.
      isGuest: Boolean(response.data.is_guest),
      // Staff may watch any game in progress (owner, 2026-10-04); the server checks it again.
      isStaff: Boolean(response.data.is_staff),
    }
  } catch (error) {
    return rejectWithValue(error.response.data)
  }
})

export const onSucceed = userReducers.setData

const thunkObject = { thunk, onSucceed }
export default thunkObject
